// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","Content":"Content-482jbcpke73rzfxqhue311gtpp1tnb1ja24v3w45dfuhfh9yqbxz9repfxq4y1ptze18vevcpkeerwpqkw9xpdpsyqudan15hwxffkt","loading":"loading-2kc8d8412d8753p383tbqepy8bcj4gv9vrkte54z1e9eeww9614b59k76hjmuu914uyaxs72ej8ug57qyg3j3xk8z7jvw7674cwswfm","pulse":"pulse-3ehfc6the7yhe8bvmf6w8uf6c4pfuwaxfmp7grfnsrk99dpjptu216qe69rt8y9tga43tkba114p6je5j21vyxwhug1ybkm9ww7ganm"};


//////////////////
// WEBPACK FOOTER
// ./src/views/InformationClause/InformationClause.module.scss
// module id = 1731
// module chunks = 0